module.exports = __webpack_public_path__ + "static/media/greenShell.e06573ef.png";